import { MD5 } from "./md5";

// concatenate the json string with a unique client id before hashing
export function generateDataId(input: unknown): string {
  return MD5.hash(JSON.stringify(input) + window.cnc?.clientId);
}

/**
 * In gRPC and Protocol Buffers, "uvarint" refers to an unsigned variable-length integer encoding
 * While the protobuf class offers a `Reader` class, it didn't work perfectly, perhaps due to the 7-bit alignment?
 * In Go, "uvarint" encoding allows unsigned 64-bit integers in a space-efficient manner, using 1 to 10 bytes depending on the value.
 *
 * @param buffer - byte fragment that contains variable series of bytes encoding the length, followed by the next series of bytes for data
 * @param offset - optional pointer position within the buffer to start reading
 */
export function decodeUVarint(buffer: Uint8Array, offset = 0) {
  let result = 0;
  let shift = 0;
  let byte: number | undefined;
  let currentOffset = offset;

  do {
    byte = buffer.at(currentOffset++);
    if (byte === undefined) {
      continue;
    }
    /* eslint-disable no-bitwise */
    result |= (byte & 0x7f) << shift; // Mask out the continuation bit and shift
    shift += 7; // Increment the shift by 7 for each subsequent byte
  } while (<number>byte >= 0x80);

  return { value: result, bytesRead: currentOffset - offset };
}
